import { useTranslation } from 'react-i18next';
import { graphql, useFragment } from 'react-relay';

import type { PaymentCompanySupportEmail_company$key } from './__generated__/PaymentCompanySupportEmail_company.graphql.ts';
import PaymentCompanySupportLink from './PaymentCompanySupportLink.tsx';

import type { ReactNode } from 'react';

type PaymentCompanySupportEmailProps = {
  company: PaymentCompanySupportEmail_company$key;
};

const PaymentCompanySupportEmail = (
  props: PaymentCompanySupportEmailProps,
): ReactNode => {
  const { t } = useTranslation();

  const company = useFragment<PaymentCompanySupportEmail_company$key>(
    graphql`
      fragment PaymentCompanySupportEmail_company on Company {
        preferences {
          support {
            email
          }
        }
      }
    `,
    props.company,
  );

  if (!company?.preferences?.support?.email) {
    return;
  }

  return (
    <PaymentCompanySupportLink
      title={t('Seller email')}
      href={`mailto:${company.preferences.support.email}`}
    >
      {company.preferences.support.email}
    </PaymentCompanySupportLink>
  );
};

export default PaymentCompanySupportEmail;
